<template>
	<section class="container module-margin" :class="classes">
		<div class="inner">
			<div class="content-inner">
				<h2 class="module-title font-size--36">
					<span>{{ data.title }}</span>
				</h2>
				<div class="description" v-if="data.description" v-html="data.description"></div>
				<div class="links-button-list" v-if="data.link">
					<Button :acf-link="data.link" :accent="btnAccent" :theme="btnTheme" icon="arrowRight" />
				</div>
			</div>
			<div class="imager" v-if="data.image && data.type === 'image'">
				<WpImage :image="data.image" size="large" class="side-image" cover background />
			</div>
			<div class="imager icon-block" v-if="data.type === 'icon' && data.icon">
				<span class="icon" v-html="tileIcon(data.icon)"></span>
			</div>
		</div>
	</section>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import Button from '@/components/elements/Button'
import { systemBig, fishBig, leaftBig, gearBig, heartchBig } from '@/icons'
import { mapGetters } from 'vuex'

export default {
	name: 'presentation',
	props: ['data'],
	computed: {
		...mapGetters(['pageTheme']),
		btnAccent() {
			let btn = this.pageTheme
			if (this.data.type === 'icon') {
				btn = this.data.icon
			}
			return btn
		},
		btnTheme() {
			let btn = this.pageTheme && this.pageTheme !== 'default' ? this.pageTheme : 'dark'
			if (this.data.type === 'icon') {
				btn = this.data.icon === 'default' ? 'dark' : this.data.icon
			}

			return this.data.type === 'cta' ? 'light' : btn
		},
		classes() {
			let classes = []
			if (this.data.image_side && this.data.type !== 'cta') classes.push('side-' + this.data.image_side)
			if (this.data.image || this.data.type === 'icon') classes.push('has-image')
			if (this.data.type === 'cta') {
				classes.push('no-image')
				classes.push('cta')
			}
			if (this.pageTheme || this.data.type === 'icon') {
				if (this.data.type === 'icon') {
					classes.push('module-theme--' + this.data.icon)
				} else {
					classes.push('module-theme--' + this.pageTheme)
				}
			}
			if (this.data.type === 'icon') {
				classes.push('has-icon')
				classes.push(this.data.icon)
			}
			//else classes.push('no-image')

			return classes.join(' ')
		},
	},

	components: {
		WpImage,
		Button,
	},
	methods: {
		tileIcon(type) {
			switch (type) {
				case 'blue':
					return fishBig()
					break
				case 'red':
					return heartchBig()
					break
				case 'green':
					return leaftBig()
					break
				case 'purple':
					return gearBig()
					break
				default:
					return systemBig()
					break
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-presentation {
	&.no-image {
		.inner {
			border-radius: $radius;
			background-color: var(--dark);
			color: #fff;
			padding: 75px;
			@include mquery($tablet) {
				padding: 50px;
			}
			@include mquery($phone) {
				padding: 25px;
			}

			.content-inner {
				text-align: center;
				max-width: 800px;
				margin: 0 auto;
			}
		}
		&.module-theme {
			&--red .inner {
				background-color: var(--red);
			}
			&--blue .inner {
				background-color: var(--blue);
			}
			&--green .inner {
				background-color: var(--green);
			}
			&--purple .inner {
				background-color: var(--purple);
			}
		}
	}
	.module-title {
		margin-top: 0;
		margin-bottom: 30px;
		z-index: 5;
		@include mquery($phone) {
			margin-bottom: 20px;
		}
	}
	.description {
		margin-top: 0;
		font-weight: 400;
	}
	.links-button-list {
		margin-top: 30px;
		@include mquery($phone) {
			margin-top: 20px;
		}
	}

	.icon-block {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 25px;
		svg {
			width: 232px;
			height: 232px;
		}
		@include mquery($phone) {
			padding-bottom: 0;
			padding-top: 30px;
			svg {
				width: 180px;
				height: 180px;
			}
		}
	}
	&.has-image {
		.inner {
			background-color: var(--gray);
		}
		&.module-theme {
			&--red .inner {
				background-color: var(--redLight);
				color: var(--red);
			}
			&--blue .inner {
				background-color: var(--blueLight);
				color: var(--blue);
			}
			&--green .inner {
				background-color: var(--greenLight);
				color: var(--green);
			}
			&--purple .inner {
				background-color: var(--purpleLight);
				color: var(--purple);
			}
		}
		&.side-right {
			.content-inner {
				@include mquery($phone) {
					order: 2;
				}
			}
			.wp-image-vue div.image {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				@include mquery($phone) {
					border-top-left-radius: $radius;
					border-bottom-right-radius: 0;
				}
			}
		}
		&.side-left {
			.content-inner {
				order: 2;
			}
			.wp-image-vue div.image {
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
				@include mquery($phone) {
					border-top-right-radius: $radius;
					border-bottom-left-radius: 0;
				}
			}
		}
		.wp-image-vue {
			height: 100%;
		}
		.wp-image-vue.background .image {
			padding-bottom: 45.25%;
			min-height: 100%;
			@include mquery($phone) {
				min-height: 200px;
			}
		}
		.inner {
			border-radius: $radius;
			display: flex;
			@include mquery($phone) {
				flex-direction: column;
			}
			.content-inner {
				max-width: 50%;
				width: 100%;
				align-self: center;
				position: relative;
				z-index: 10;
				padding: 75px;
				@include mquery($tablet) {
					padding: 50px;
				}
				@include mquery($phone) {
					max-width: 100%;
					padding: 25px;
					text-align: center;
				}
			}
			.imager {
				max-width: 50%;
				width: 100%;
				@include mquery($phone) {
					max-width: 100%;
				}
			}
		}
	}
}
</style>
